// src/App.jsx

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FloatingChatBot from './helpers/FloatingChatBot/FloatingChatBot';
import WhatsAppButton from './componentes/shared/WhatsAppButton';
import NavBar from './componentes/shared/NavBar';

// Estilos globales que ningún componente auto-importa
import './componentes/shared/Footer.css';

// Carga diferida de componentes para mejorar el rendimiento
const Form = lazy(() => import('./helpers/RegistroForm/Form'));
const Condiciones = lazy(() => import('./componentes/Condiciones'));
const Simulador = lazy(() => import('./pages/Simulador/Simulador'));
const QuienesSomos = lazy(() => import('./pages/QuienesSomos/QuienesSomos'));
const Footer = lazy(() => import('./componentes/shared/Footer'));
const ChatBotPage = lazy(() => import('./pages/chatbot/chatbot'));
const PanelAdmin = lazy(() => import('./pages/PanelAdmin/PanelAdmin'));
const ConfirmarCorreo = lazy(() => import('./pages/PanelAdmin/ConfirmarCorreo'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));
const Login = lazy(() => import('./pages/Login/Login'));
const Register = lazy(() => import('./pages/register/Register'));

function App() {
  return (
    <Router>
      <div>
        <NavBar />
        <Suspense fallback={<div>Cargando...</div>}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Form />
                  <Condiciones />
                  <Simulador />
                  <QuienesSomos />
                  <Footer />
                </>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/chatbot" element={<ChatBotPage />} />
            <Route path="/panel-admin/*" element={<PanelAdmin />} />
            <Route path="/confirmar-correo" element={<ConfirmarCorreo />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <FloatingChatBot />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default React.memo(App);
